import { Button, Empty, Loading, Title } from "@components";
import { If } from "@components/control-statements";
import { FlowAPI } from "@providers/FlowAPI";
import React, { useEffect, useState } from "react";
import { isMobile } from "react-device-detect";

import { Environment } from "@core/Environment";
import { useNavigate } from "react-router-dom";

import { FlowList } from "@containers/flows/FlowList";
import flowListStyle from "@styles/pages/flow/FlowList.module.scss";

export default function Fluxos() {
  const [loadingFlows, setLoadingFlows] = useState(false);
  const [flows, setFlows] = useState([]);

  const [pageLoaded, setPageLoaded] = useState(false);
  const [environmentName, setEnvironmentName] = useState("");

  useEffect(() => {
    loadMyFlows();

    setPageLoaded(true);
    setEnvironmentName(Environment.name);
  }, []);

  const loadMyFlows = async () => {
    setLoadingFlows(true);
    const myFlowsResponse = await FlowAPI.getArchivedFlows();

    setLoadingFlows(false);
    setFlows(myFlowsResponse.getData([]));
  };

  const navigate = useNavigate();

  return (
    <>
      <If cond={isMobile && pageLoaded}>
        <Empty>
          <p>Essa página não está disponível para dispositivos móveis</p>
        </Empty>
      </If>

      <If cond={!isMobile && pageLoaded}>
        <Title
          backTo={{ url: "/fluxos", name: "Fluxos" }}
          title="Fluxos Arquivados"
        />
        <If cond={loadingFlows}>
          <div className="w-100 d-flex align-center justify-center flex-1 pt-25 pb-25">
            <Loading />
          </div>
        </If>
        <If cond={flows.length > 0 && !loadingFlows}>
          <p className={flowListStyle.label}>Desagrupados ({flows.length})</p>
        </If>
        <FlowList
          flows={flows}
          onFlowClick={(flow) => navigate(`/fluxos/${flow.id}`)}
        />
        <If cond={flows.length == 0 && !loadingFlows}>
          <Empty>
            <i className="far fa-arrows-split-up-and-left" />
            <p>Não há fluxos arquivados.</p>
            <span>
              Através dessa tela, será possível visualizar o fluxos arquivados
              no Olga.
            </span>
          </Empty>
        </If>
      </If>
    </>
  );
}
